import React, { useState } from "react";
import styles from "./PricingContent.module.css";
import PricingCards from "./PricingCards";


const PricingContent = ({setIsRegisterOpen}) => {
  const [billing, setBilling] = useState("yearly");

  return (
    <section className={styles.pricing}>

      <div className={styles.toggle}>
  {/* <button
    className={`${styles.toggleBtn} ${
      billing === "monthly" ? styles.active : ""
    }`}
    onClick={() => setBilling("monthly")}
  >
    Monthly
  </button> */}

  <button
    className={`${styles.toggleBtn} ${
      billing === "yearly" ? styles.active : ""
    }`}
    onClick={() => setBilling("yearly")}
  >
    Yearly
  </button>
</div>

      <PricingCards setIsRegisterOpen={setIsRegisterOpen}  billing={billing} />
    
    </section>
  );
};

export default PricingContent;